/* eslint-disable */
import React, { PureComponent } from 'react'
import { crypto } from '@binance-chain/javascript-sdk'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Big from 'big.js'

import { Consumer as BNCClientConsumer } from '../context/BNCClientProvider'
import { Consumer as WalletConnectClientConsumer } from '../context/WalletConnectProvider'
import Notifycation from '../../components/common/Notifycation'
import message from '../../components/common/Message'
import { Button } from '../../components/common/Button'
import OrderForm from './OrderFormMobile'

import { setOpenOrder } from '../../redux/order/action'
import { setNotLoginNotify, setTriggerElement, setLoading } from '../../redux/global/action'
import { setNeedAuth } from '../../redux/account/action'
import { setWalletConnectURI } from '../../redux/walletConnect/action'
import { setPriceCheckText, setShowPriceNotify, setPriceCheck } from '../../redux/exchange/action'
import request from '../../utils/httpRequest'
import { roundValue } from '../../utils/number'
import { withI18n } from '../../i18n/util'
import hasPrivateKey, { isUnlockWithWalletConnect } from '../../utils/account'
import zIndex from '../../utils/zIndexScale'
// import { setFingerPrint } from '../../utils/fingerPrint'

const Wrapper = styled.div`
  position: absolute;
  right: 0;
  background: ${({ theme }) => theme.exchangeSecondBg};
  z-index: ${zIndex.placeOrder};
  display: none;
  width: 100%;
  @media (min-width: 20px) and (max-width: 768px) {
    display: block;
  }
`

const Header = styled.div`
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #131722;
  box-shadow: ${({ theme }) => theme.exchangeHeadShadow};
`

const Title = styled.div`
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-indent: 12px;
`

const Content = styled.div`
  padding: 20px 10px;
  color: #848e9c;
  display: flex;
  justify-content: space-around;
`

const OrderFormWrap = styled.div`
  width: 48%;
`

const PlaceOrderButton = styled(Button)`
  width: 222px;
  height: 36px;
  line-height: 36px;
  opacity: ${({ disabled }) => disabled ? '0.3' : '1'};
  span {
    line-height: inherit;
  }
`

export const BuyButton = styled(PlaceOrderButton)`
  background: linear-gradient(90deg, rgba(0, 192, 135, 1), rgba(65, 222, 221, 1));
`

export const SellButton = styled(PlaceOrderButton)`
  background: linear-gradient(90deg, rgba(234, 0, 112, 1), rgba(252, 84, 179, 1));
`

const ErrMsg = styled.p`
  font-size: 12px;
  line-height: 12px;
  position: absolute;
  top: -15px;
  color: rgb(239, 75, 90);
`

export const LoadingModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  .loading {
    font-size: 60px;
  }
`

export const LoadingModalTitle = styled.h3`
  margin: 14px 0;
`

export const LoadingModalContent = styled.p`
  font-size: 14px;
  color: #76808f;
`


class PlaceOrder extends PureComponent {
  static propTypes = {
    privateKey: PropTypes.string,
    address: PropTypes.string,
    quoteAsset: PropTypes.string,
    baseAsset: PropTypes.string,
    tickerSize: PropTypes.string,
    lotSize: PropTypes.string,
    openOrders: PropTypes.array,
    latestPrice: PropTypes.string,
    balances: PropTypes.array,
    dispatch: PropTypes.func,
    currentPrice: PropTypes.string,
    buyAmount: PropTypes.string,
    sellAmount: PropTypes.string,
    history: PropTypes.object,
    deviceInfo: PropTypes.object,
    cryptoCurrencyRate: PropTypes.object,
    xBNBPair: PropTypes.string,
    isLoading: PropTypes.bool,
    formatI18nText: PropTypes.func,
  }

  static defaultProps = {
    privateKey: '',
    address: '',
    quoteAsset: '',
    baseAsset: '',
    currentPrice: '',
    buyAmount: '',
    sellAmount: '',
    openOrders: [],
    latestPrice: '',
    balances: [],
    tickerSize: '0.00000001',
    lotSize: '0.00000001',
    dispatch: () => {},
    history: {},
    deviceInfo: {},
    cryptoCurrencyRate: {},
    xBNBPair: '',
    isLoading: false,
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      askValue: '',
      bidValue: '',
      askTotal: '',
      bidTotal: '',
      buyAmount: '',
      sellAmount: '',
      notifyType: '',
      notifyTitle: '',
      notifyMsg: '',
      showNotify: false,
      buyErrMsg: '',
      sellErrMsg: '',
      type: 1, //1-buy, 2-sell
    }
  }

  componentDidUpdate(prevProps) {
    const {
      latestPrice: lastPrice,
      tickerSize,
      buyAmount,
      sellAmount,
      currentPrice,
      quoteAsset,
      baseAsset,
    } = this.props

    const { askValue, bidValue } = this.state

    const latestPrice = currentPrice || lastPrice

    if (
      (!askValue && !bidValue) ||
      buyAmount != prevProps.buyAmount ||
      sellAmount != prevProps.sellAmount ||
      prevProps.currentPrice != currentPrice ||
      (quoteAsset !== prevProps.quoteAsset && baseAsset !== prevProps.baseAsset)
    ) {
      this.setState({
        askValue: askValue === 'void' ? '' : latestPrice,
        bidValue: bidValue === 'void' ? '' : latestPrice,
        buyAmount,
        sellAmount,
        bidTotal: latestPrice
          ? roundValue(parseFloat(latestPrice, 10) * parseFloat(sellAmount, 10), tickerSize)
          : '',
        askTotal: buyAmount
          ? roundValue(parseFloat(latestPrice, 10) * parseFloat(buyAmount, 10), tickerSize)
          : '',
      })
    }
  }

  _checkQuantity = (side, quantity) => {
    const { balances, baseAsset, quoteAsset } = this.props
    let result = true
    if (side === 1) {
      const { askTotal } = this.props
      const availableBalance = balances.find(b => b.symbol === quoteAsset)
      if (!availableBalance || availableBalance.free < askTotal) {
        message.warn('not enough balance')
        result = false
      }
    }

    if (side === 2) {
      const availableBalance = balances.find(b => b.symbol === baseAsset)
      if (!availableBalance || availableBalance.free < quantity) {
        message.warn('not enough balance')
        result = false
      }
    }
    return result
  }

  _checkRoundSize = (roundValue, roundSize) => {
    try {
      roundSize = new Big(roundSize)
      roundValue = new Big(roundValue)
      const roundResult = +roundValue.mod(roundSize).toString()
      return roundResult > 0 ? false : true
    } catch (err) {
      return true
    }
  }

  _placeOrder = async (client, side, price, quantity, currentTarget, wcClient) => {
    const {
      address,
      baseAsset,
      quoteAsset,
      privateKey,
      dispatch,
      latestPrice,
      deviceInfo,
      hasPriceChecked,
      tickerSize,
      lotSize,
      history,
    } = this.props

    if (isUnlockWithWalletConnect() && !wcClient.connected()) {
      const uri = await wcClient.startSession(false)
      console.log('WalletConnect URI', uri)
      dispatch(setWalletConnectURI(uri))
      dispatch(setTriggerElement(currentTarget))
      return
    }

    if (!hasPrivateKey()) {
      history.push('/unlock')
    }

    if (!address) {
      dispatch(setNotLoginNotify(true))
      return
    }

    if (!this._checkQuantity(side, quantity)) {
      return
    }

    if (!this._checkRoundSize(price, tickerSize)) {
      if (side === 1) {
        message.warn(`price should be integer multiples of ${parseFloat(lotSize)}`)
      } else {
        message.warn(`price should be integer multiples of ${parseFloat(lotSize)}`)
      }

      return
    }

    if (!this._checkRoundSize(quantity, lotSize)) {
      if (side === 1) {
        message.warn(`amount should be integer multiples of ${parseFloat(lotSize)}`)
      } else {
        message.warn(`amount should be integer multiples of ${parseFloat(lotSize)}`)
      }

      return
    }

    if (!price || price < 0) {
      message.warn('please input correct price')
      return
    }

    if (!quantity || quantity < 0) {
      message.warn('please input correct amount')
      return
    }

    if (!privateKey) {
      dispatch(setTriggerElement(currentTarget))
      dispatch(setNeedAuth(true))
      return
    }

    if (price > latestPrice * 1.2 && !hasPriceChecked && side === 1) {
      const priceNotifyText = `Your order price will be 20% higher than
        the latest market price. Please proceed cautiously.`

      dispatch(setTriggerElement(currentTarget))
      dispatch(setPriceCheckText(priceNotifyText))
      dispatch(setShowPriceNotify(true))
      dispatch(setPriceCheck(true))
      return
    }

    if (price < latestPrice * 0.8 && !hasPriceChecked && side === 2) {
      const priceNotifyText = `Your order price will be 20% less than
        the latest market price. Please proceed cautiously.`

      dispatch(setTriggerElement(currentTarget))
      dispatch(setPriceCheckText(priceNotifyText))
      dispatch(setShowPriceNotify(true))
      dispatch(setPriceCheck(true))
      return
    }

    const account = (await request.getAccount(address)) || {}

    privateKey !== 'HARDWARE' && (await client.setPrivateKey(privateKey))

    const accCode = crypto.decodeAddress(address)
    const sequence = parseInt(account.sequence, 10)

    const placeOrderMsg = {
      sender: accCode,
      id: `${accCode.toString('hex')}-${sequence + 1}`.toUpperCase(),
      symbol: `${baseAsset}_${quoteAsset}`,
      ordertype: 2,
      side,
      price: roundValue(price, tickerSize),
      quantity: roundValue(quantity, lotSize),
      timeinforce: 1,
      msgType: 'NewOrderMsg',
    }

    try {
      dispatch(setLoading(true))
      const res = await client.placeOrder(
        address,
        `${baseAsset}_${quoteAsset}`,
        side,
        price,
        quantity,
        sequence
      )
      dispatch(setLoading(false))
      const hash = res.result[0] && res.result[0].hash
      // setFingerPrint(deviceInfo, 'place_order_mobile', address, hash)
      if (res.status === 200) {
        const sideText = side === 1 ? 'Buy' : 'Sell'
        this.setState(
          {
            notifyType: 'success',
            notifyMsg: `Submitted exchange limit ${sideText} order for ${quantity} ${baseAsset.replace(
              /-.+/,
              ''
            )}
          by using ${quoteAsset}`,
            notifyTitle: `Limit ${sideText} Order Created`,
            showNotify: true,
            buyAmount: '',
            sellAmount: '',
          },
          () => {
            dispatch(setPriceCheck(false))
            this._updateOpenOrders(placeOrderMsg, res.result[0])
          }
        )
      } else {
        this.setState(
          {
            notifyType: 'fail',
            notifyMsg: res.msg || 'error occured',
            notifyTitle: 'Order Error',
            showNotify: true,
          },
          () => {
            ispatch(setPriceCheck(false))
            dispatch(setLoading(false))
          }
        )
      }
    } catch (err) {
      console.log(err)
      this.setState(
        {
          notifyType: 'fail',
          notifyMsg: err.message || 'error occured',
          notifyTitle: 'Order Error',
          showNotify: true,
          hasPriceChecked: false,
        },
        () => {
          dispatch(setPriceCheck(false))
          dispatch(setLoading(false))
        }
      )
    }
  }

  _buy = (client, wcClient) => (ev, price, amount, total) => {
    this.setState({ askTotal: total })
    this._placeOrder(client, 1, price, amount, ev.currentTarget, wcClient)
  }

  _sell = (client, wcClient) => (ev, price, amount) => {
    this._placeOrder(client, 2, price, amount, ev.currentTarget, wcClient)
  }

  _updateOpenOrders = (order, data) => {
    const { openOrders, dispatch } = this.props
    openOrders.unshift({
      transactionHash: data.hash,
      orderCreateTime: new Date(),
      symbol: order.symbol,
      side: order.side,
      price: order.price,
      quantity: order.quantity,
      cumulateQuantity: 0,
      total: order.price * order.quantity,
      op: '',
      orderId: order.id,
    })

    dispatch(setOpenOrder({ order: openOrders }))
  }

  _getBalance = quoteAsset => {
    const { balances } = this.props
    for (let i = 0, len = balances.length; i < len; i++) {
      if (quoteAsset === balances[i].symbol) {
        return balances[i].free
      }
    }

    return 0
  }

  render() {
    const { quoteAsset, baseAsset, tickerSize, lotSize, xBNBPair, cryptoCurrencyRate, isLoading } = this.props

    const {
      askValue,
      bidValue,
      buyAmount,
      sellAmount,
      notifyMsg,
      notifyTitle,
      notifyType,
      showNotify,
    } = this.state

    const quoteAssetBalance = this._getBalance(quoteAsset)
    const baseAssetBalance = this._getBalance(baseAsset)

    return (
      <WalletConnectClientConsumer>
        {wcClient => (
          <BNCClientConsumer>
            {bncClient => (
              <Wrapper>
                <Header>
                  <Title>Limit Order</Title>
                </Header>
                <Content>
                  <OrderFormWrap>
                    <OrderForm
                      type={1}
                      baseAsset={baseAsset}
                      quoteAsset={quoteAsset}
                      availableBalance={quoteAssetBalance}
                      tickerSize={tickerSize}
                      lotSize={lotSize}
                      price={askValue}
                      amount={buyAmount}
                      xBNBPair={xBNBPair}
                      cryptoCurrencyRate={cryptoCurrencyRate}
                      onClick={this._buy(bncClient, wcClient)}
                      isLoading={isLoading}
                    />
                  </OrderFormWrap>
                  <OrderFormWrap>
                    <OrderForm
                      type={2}
                      baseAsset={baseAsset}
                      quoteAsset={quoteAsset}
                      availableBalance={baseAssetBalance}
                      tickerSize={tickerSize}
                      lotSize={lotSize}
                      price={bidValue}
                      amount={sellAmount}
                      xBNBPair={xBNBPair}
                      cryptoCurrencyRate={cryptoCurrencyRate}
                      onClick={this._sell(bncClient, wcClient)}
                      isLoading={isLoading}
                    />
                  </OrderFormWrap>
                </Content>
                {showNotify && (
                  <Notifycation
                    type={notifyType}
                    msg={notifyMsg}
                    title={notifyTitle}
                    close={() => {
                      this.setState({ showNotify: false })
                    }}
                  />
                )}
              </Wrapper>
            )}
          </BNCClientConsumer>
        )}
      </WalletConnectClientConsumer>
    )
  }
}

const mapStateToProps = ({
  account: { privateKey, address, userInfo },
  exchange: {
    currentTrade,
    currentPrice,
    buyAmount,
    sellAmount,
    hasPriceChecked,
    cryptoCurrencyRate,
  },
  order: { openOrders },
  trade: { tradeHistory },
  tickers: { tickerSize, lotSize, symbolTickers },
  globalData: { deviceInfo, isLoading },
}) => {
  const currentTradeArr = currentTrade.split('_')
  const trade = (tradeHistory && tradeHistory.trade[0]) || {}
  const currentTicker = symbolTickers.find(t => t.symbol && t.symbol.includes(currentTrade)) || {}
  const xBNBPair = symbolTickers.find(st => st.symbol === `BNB_${currentTradeArr[1]}`)
  const props = {
    privateKey,
    address,
    quoteAsset: currentTradeArr[1],
    baseAsset: currentTradeArr[0],
    latestPrice: roundValue(trade.price || currentTicker.price, tickerSize[currentTrade]),
    openOrders: openOrders.order,
    balances: userInfo.balances,
    currentPrice: roundValue(currentPrice, tickerSize[currentTrade]),
    buyAmount,
    sellAmount,
    hasPriceChecked,
    tickerSize: tickerSize[currentTrade],
    lotSize: lotSize[currentTrade],
    deviceInfo,
    cryptoCurrencyRate,
    xBNBPair,
    isLoading,
  }

  return props
}

export default connect(mapStateToProps)(withRouter(withI18n(PlaceOrder)))
